import { createFileRoute } from "@tanstack/react-router";
import { AboutPageView } from "@/components/about/AboutPageView";
import { getAboutPage } from "@/lib/marketing.functions";
import { isSanityPreviewRequest } from "@/lib/sanity";
import { DEFAULT_ABOUT_PAGE } from "@/lib/marketingDefaults";
import "@/styles/marketing.css";

export const Route = createFileRoute("/about")({
  validateSearch: (search: Record<string, unknown>) => search,
  loaderDeps: ({ search }) => ({ search }),
  /** Always revalidate — marketing copy changes often in Studio. */
  staleTime: 0,
  loader: async ({ deps }) => {
    const preview = isSanityPreviewRequest(deps.search as Record<string, unknown>);
    const about = await getAboutPage({ data: { preview } });
    return { about: about ?? DEFAULT_ABOUT_PAGE };
  },
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.about.seo.title ?? "About · Pulse" },
      {
        name: "description",
        content:
          loaderData?.about.seo.description ??
          "Why Pulse exists — and where we're going.",
      },
    ],
  }),
  component: AboutRoute,
});

function AboutRoute() {
  const { about } = Route.useLoaderData();
  return <AboutPageView data={about} />;
}
